<aside class="card">
  <form
    class="container form-gap"
    [ngClass]="{
      'was-validated': !isValid
    }"
  >
    <!-- <div *ngIf="isModal" class="row">
      <div class="col-12">
        <div class="contact-header">
          <img
            style="margin-right: 28px"
            src="assets/img/icons/logo-header-lg.svg"
            alt="NYCHA Logo"
            width="58"
            height="71"
          />

          <h1 class="skiptranslate">Contact NYCHA</h1>
        </div>
      </div>
    </div> -->
    <div class="row">
      <div class="col-12">
        <div class="contact-nycha">
          <h1 class="skiptranslate">Contact NYCHA</h1>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 my-2">
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            name="emailType"
            id="projectInquiry"
            value="ProjectInquiry"
            (change)="updateEmailType($event)"
            checked
          />
          <label class="form-check-label" for="projectInquiry">Project Inquiry</label>
        </div>

        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            name="emailType"
            id="generalInquiry"
            (change)="updateEmailType($event)"
            value="GeneralInquiry"
          />
          <label class="form-check-label" for="generalInquiry">General Inquiry</label>
        </div>

        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            name="emailType"
            id="technicalDifficulties"
            (change)="updateEmailType($event)"
            value="TechnicalDifficulties"
          />
          <label class="form-check-label" for="technicalDifficulties">Technical Difficulties</label>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-6 input-col">
        <div class="mb-3">
          <label for="developmentName" class="form-label">Development</label>
          <select
            name="developmentName"
            required
            class="form-control form-select"
            aria-label="Development name dropdown"
            (change)="updateFilteredList($event)"
            [disabled]="isDropdownDisabled"
            [(ngModel)]="developmentId"
          >
            <option value="0">Any</option>
            <option
              class="skiptranslate"
              *ngFor="let development of developmentList"
              [value]="development.id"
              
            >
              {{ development.name }}
            </option>
          </select>
        </div>

        <div class="mb-3 input-col">
          <label for="projectName" class="form-label">Project</label>
          <select
            name="projectName"
            class="form-control form-select"
            aria-label="Project name dropdown"
            (change)="selectProject($event)"
            [disabled]="isDropdownDisabled"
          >
            <option value="">Any</option>
            <option
              [value]="project.id"
              [selected]="projectId === project.id"
              *ngFor="let project of filteredProjectList"
            >
              {{ project.name | titleCasewithAvoidWords | simplifyWords }}
            </option>
          </select>
        </div>

        <div class="mb-3 input-col">
          <label for="firstName" class="form-label">First Name</label>
          <input
            type="text"
            class="form-control form-control-lg"
            id="firstName"
            name="firstName"
            placeholder="Enter Your First Name"
            [(ngModel)]="payload.email.FirstName"
            required
          />
        </div>

        <div class="mb-3 input-col">
          <label for="lastName" class="form-label">Last Name</label>
          <input
            type="text"
            class="form-control form-control-lg"
            id="lastName"
            name="lastName"
            placeholder="Enter Your Last Name"
            [(ngModel)]="payload.email.LastName"
            required
          />
        </div>

        <div class="mb-3 input-col">
          <label for="email" class="form-label">E-mail</label>
          <input
            type="email"
            class="form-control form-control-lg"
            id="email"
            name="email"
            placeholder="Enter Your E-mail"
            [(ngModel)]="payload.email.Email"
            required
          />
        </div>

        <div class="mb-3 input-col">
          <label for="phoneNumber" class="form-label">Phone (Optional)</label>
          <input
            type="text"
            class="form-control form-control-lg"
            id="phoneNumber"
            name="phoneNumber"
            placeholder="(XXX)-XXX-XXXX"
            [(ngModel)]="payload.email.Phone"
            (input)="formatPhoneNumber($event)"
            (keypress)="restrictNonNumeric($event)"
            maxlength="14" 
            pattern="\d*"
          />
        </div>
      </div>

      <div class="col-6 input-col">
        <div class="mb-3 d-flex textarea-control">
          <label for="message" class="form-label">Message</label>
          <textarea
            class="form-control"
            id="message"
            name="message"
            rows="10"
            [(ngModel)]="payload.email.Message"
            required
          ></textarea>
        </div>
      </div>
    </div>

    <div>
      <div class="btn-location">
        <button type="submit" class="btn" (click)="sendPost()">Submit</button>
      </div>
    </div>
  </form>
</aside>
